import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";

interface Props {
  open: boolean;
  handleDrawerClose: () => void;
  onOpenPdfPreview: () => void;
  shipment?: SupplierShipment;
}

export function SupplierShipmentSideBarMenu(props: Props) {
  const { open, handleDrawerClose, onOpenPdfPreview, shipment } = props;

  if (!shipment) {
    return null;
  }

  return (
    <Drawer
      variant="persistent"
      anchor="right"
      open={open}
      sx={{
        "& .MuiDrawer-paper": {
          minWidth: "240px",
        },
      }}
    >
      <div>
        <IconButton onClick={handleDrawerClose}>
          <ChevronRightIcon />
        </IconButton>
      </div>
      <List>
        <ListItem>
          <Tooltip
            title={
              shipment.info.type === "MULTI_SHIPMENT_PROJECT"
                ? "Export is only supported for single shipments"
                : ""
            }
            placement="left"
          >
            <span>
              <ListItemButton
                onClick={onOpenPdfPreview}
                disabled={shipment.info.type === "MULTI_SHIPMENT_PROJECT"}
              >
                <ListItemIcon>
                  <PictureAsPdfIcon />
                </ListItemIcon>
                <ListItemText primary="Export PDF" />
              </ListItemButton>
            </span>
          </Tooltip>
        </ListItem>
      </List>
    </Drawer>
  );
}
